module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-scroll-transition",
    class: ("mt-scroll-transition--" + _vm.direction + "-" + _vm.distance + "__" + _vm.status),
    attrs: {
      "id": _vm.randomId
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06648448","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/mtui/scroll-trans/ScrollTrans.vue
// module id = a0w2
// module chunks = 0